const state = {
  notifications: [],
}

const getters = {
  notifications: state => state.notifications,
}

const mutations = {
  setNotifications: (state, notifications) =>
    (state.notifications = notifications),
}

const actions = {
  addNotification ({ commit, state, dispatch }, { type, message }) {
    const notifications = state.notifications
    const notification = {
      type,
      message,
      timestamp: Date.now(),
    }
    notifications.push(notification)
    commit("setNotifications", notifications)
    setInterval(() => {
      dispatch("removeNotification", notification)
    }, 3000)
  },
  removeNotification ({ commit, state }, notification) {
    const notifications = state.notifications.filter(
      notif => notif.timestamp !== notification.timestamp
    )
    commit("setNotifications", notifications)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/notification/notification.module.js